import { render, staticRenderFns } from "./EnacAtplDashboardRegistrationLearnerPhases.vue?vue&type=template&id=bb1c1214"
import script from "./EnacAtplDashboardRegistrationLearnerPhases.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardRegistrationLearnerPhases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports